import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Gallery = ({ images = [], alt = "" }) => {
  const [idx, setIdx] = useState(0);
  const [dir, setDir] = useState(1);
  if (!images.length) return null;
  const go = (n) => { setDir(n > idx ? 1 : -1); setIdx((n + images.length) % images.length); };
  const prev = () => { setDir(-1); setIdx((i) => (i - 1 + images.length) % images.length); };
  const next = () => { setDir(1); setIdx((i) => (i + 1) % images.length); };

  return (
    <div data-testid="product-gallery">
      <div style={{ position: "relative", borderRadius: 4, border: "1px solid var(--border)", overflow: "hidden", background: "var(--surface)", aspectRatio: "1/1" }}>
        <AnimatePresence initial={false} custom={dir} mode="popLayout">
          <motion.img
            key={idx}
            src={images[idx]}
            alt={`${alt} — ${idx + 1}`}
            data-testid="gallery-main"
            custom={dir}
            initial={{ opacity: 0, x: dir * 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: dir * -40 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
          />
        </AnimatePresence>
        {images.length > 1 && (
          <>
            <button onClick={prev} data-testid="gallery-prev" aria-label="Précédent" style={arrow("left")}><ChevronLeft size={20} /></button>
            <button onClick={next} data-testid="gallery-next" aria-label="Suivant" style={arrow("right")}><ChevronRight size={20} /></button>
            <div style={{ position: "absolute", bottom: 12, left: 0, right: 0, display: "flex", justifyContent: "center", gap: 6 }}>
              {images.map((_, i) => (
                <span key={i} style={{ width: 6, height: 6, borderRadius: "50%", background: i === idx ? "var(--accent)" : "rgba(245,245,243,0.4)" }} />
              ))}
            </div>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div style={{ display: "flex", gap: 10, marginTop: 12, flexWrap: "wrap" }}>
          {images.map((src, i) => (
            <button key={i} onClick={() => go(i)} data-testid={`gallery-thumb-${i}`} aria-label={`Image ${i + 1}`}
              style={{ padding: 0, width: 64, height: 64, borderRadius: 4, overflow: "hidden", cursor: "pointer", background: "none", border: `2px solid ${i === idx ? "var(--accent)" : "var(--border)"}` }}>
              <img src={src} alt="" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const arrow = (side) => ({
  position: "absolute", top: "50%", transform: "translateY(-50%)", [side]: 10,
  width: 40, height: 40, borderRadius: "50%", border: "1px solid var(--border)",
  background: "rgba(10,10,10,0.6)", backdropFilter: "blur(6px)", color: "var(--text)",
  display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 2,
});
